import { css, fillOutlined, circle } from './draw-utils';
import type { ProceduralDef } from '../types';

const STEEL = 0x9aa0b0;
const NORTH = 0xe0524a; // red pole (pull)
const SOUTH = 0x4a78e0; // blue pole (push)

/**
 * Magnet — a horseshoe dipole. Frame 0 idle / 1 charged (poles
 * flare while it pulls or pushes the ship). docs/02 boss pool.
 */
export const bossMagnetBody: ProceduralDef = {
  key: 'boss/magnet/body',
  width: 140,
  height: 140,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const charged = frame === 1;

    const halo = ctx.createRadialGradient(c, c, 18, c, c, c);
    halo.addColorStop(0, charged ? 'rgba(180,150,255,0.4)' : 'rgba(154,160,176,0.22)');
    halo.addColorStop(1, 'rgba(154,160,176,0)');
    circle(ctx, c, c, c);
    ctx.fillStyle = halo;
    ctx.fill();

    // Horseshoe body — thick U, open downward
    ctx.lineCap = 'butt';
    ctx.beginPath();
    ctx.arc(c, c - 6, 40, Math.PI, 0, false);
    ctx.lineTo(c + 40, c + 40);
    ctx.lineTo(c + 22, c + 40);
    ctx.lineTo(c + 22, c - 6);
    ctx.arc(c, c - 6, 22, 0, Math.PI, true);
    ctx.lineTo(c - 22, c + 40);
    ctx.lineTo(c - 40, c + 40);
    ctx.closePath();
    fillOutlined(ctx, STEEL, 5);

    // Pole tips
    const pole = (x: number, col: number): void => {
      ctx.fillStyle = css(col);
      ctx.fillRect(x - 9, c + 34, 18, 12);
      if (charged) {
        circle(ctx, x, c + 46, 12);
        ctx.fillStyle = `${css(col)}`;
        ctx.globalAlpha = 0.4;
        ctx.fill();
        ctx.globalAlpha = 1;
      }
    };
    pole(c - 31, NORTH);
    pole(c + 31, SOUTH);
    void h;
  },
};
